export const styles = {
    root: {
        
        width: "100%"
    }
}